import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_DOMAIN, API_ENDPOINTS } from '../components/constants';
import { Button, Checkbox, Divider, Input, message, Modal, Rate, Select, Space, Table, Tag, Tooltip } from 'antd';
import { ClusterOutlined, DeleteOutlined, EditOutlined, EnvironmentOutlined, InfoCircleOutlined, PhoneOutlined, PlusOutlined, PlusSquareOutlined, SaveOutlined, SearchOutlined, ShopOutlined, UserOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import TextArea from 'antd/es/input/TextArea';
import { useCommonApiCall } from '../components/Api/commonApiCall';

function Supplier() {
    const { CommonApiCall } = useCommonApiCall()

    const deafaultNumberInfo = (<div className='flex justify-center' style={{ color: "gray" }}><i>Please enter a valid whatsapp number above first</i></div>);

    const validatePhoneNumber = (phoneNumber) => {
        try {
            const parsedNumber = parsePhoneNumberFromString("+" + phoneNumber);
            if (!parsedNumber) {
                return { valid: false, message: "Invalid phone number format" };
            }

            if (!parsedNumber.isValid()) {
                return { valid: false, message: "Phone number is not valid for detected country" };
            }

            return {
                valid: true,
                country: parsedNumber.country,
                number: parsedNumber.formatInternational(),
                type: parsedNumber.getType() // e.g., "MOBILE" or "FIXED_LINE"
            };
        } catch (error) {
            console.log(error);
        }
    };

    const [supplierSet, setsupplierSet] = useState([]);
    const [validMobileNumber, setValidMobileNumber] = useState(true);
    const [duplicateSupplier, setDuplicateSupplier] = useState(null); // existing supplier found by phone
    const phoneCheckTimerRef = useRef(null);

    const [tagSet, setTagSet] = useState([]);
    const [tagSuggestions, setTagSuggestions] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const [tagFilter, setTagFilter] = useState([]);
    const [excludeUzdpart, setExcludeUzdpart] = useState(true);

    const [whatsapp_number_status, set_whatsapp_number_status] = useState(deafaultNumberInfo);

    //Top-Bar Items
    const [addSupplierModal, setAddSupplierModal] = useState(false);
    const handleAddSupplierOpen = () => {
        reload_supplier_tags();
        setAddSupplierModal(true);
    }
    const handleAddSupplierClose = () => {
        setAddSupplierModal(false);
    }

    //Main Table Loading animation toggle
    const [tableLoading, setTableLoading] = useState(false);

    //supplier formdata
    const [supplierId, setSupplierId] = useState(null);
    const [SupplierMob, setSupplierMob] = useState(null);
    const [SupplierName, setSupplierName] = useState(null);
    const [SupplierContactPersonName, setSupplierContactPersonName] = useState(null);
    const [SupplierAddress, setSupplierAddress] = useState(null);
    const [SupplierTags, setSupplierTags] = useState([]);

    //Loading bool and misc flags
    const [supplierAddEditModalTitle, setSupplierAddEditModalTitle] = useState("Add New Supplier")
    const [addModalButtonLoading, setAddModalButtonLoading] = useState(false)
    const [tagManagementButtonLoading, setTagManagementButtonLoading] = useState(false)
    const [supplier_tag_loading, setSupplier_tag_loading] = useState(false)


    //clear supplier add form data
    const clearSupplierFormData = () => {
        setSupplierId(null);
        setSupplierMob(null);
        setSupplierName(null);
        setSupplierContactPersonName(null);
        setSupplierAddress(null);
        setSupplierTags([]);
        setCurrentSupplierInfo([]);
        setDuplicateSupplier(null);
        clearTimeout(phoneCheckTimerRef.current);
    }


    //Delete supplier
    const [deleteFinalSupplierModal, setDeleteFinalSupplierModal] = useState(false);
    const [currentSupplierInfo, setCurrentSupplierInfo] = useState([]);
    const [supplierDisableReason, setSupplierDisableReason] = useState(null);

    //check all tags controllers
    const checkAll = tagSuggestions?.length === (SupplierTags.length);
    const indeterminate = (SupplierTags.length) > 0 && (SupplierTags.length) < tagSuggestions?.length;

    const onCheckAllChange = (e) => {
        setSupplierTags(e.target.checked ? tagSuggestions : []);
    };
    const handleSupplierTagChange = (selectedTagIds) => {
        setSupplierTags(tagSuggestions.filter(e => selectedTagIds.includes(e.value)))
    }
    const handledeleteFinalSupplierModalOpen = () => {
        setDeleteFinalSupplierModal(true)
    }
    const handledeleteFinalSupplierModalClose = () => {
        setDeleteFinalSupplierModal(false)
    }
    const handleDeleteSupplier = (supplier) => {
        setCurrentSupplierInfo(supplier)
        handledeleteFinalSupplierModalOpen();
    }
    const closeDelteSupplier = () => {
        setSupplierDisableReason(null);
        setCurrentSupplierInfo([]);
        handledeleteFinalSupplierModalClose();
    }
    const handleSupplierDelete = async () => {
        if (!supplierDisableReason) {
            message.warning(`Please enter a reason for disabling this supplier`)
        }
        else {
            try {
                const response = await CommonApiCall({
                    api_key: "uzdpart",
                    id: currentSupplierInfo.id,
                    reason: supplierDisableReason,
                }, API_ENDPOINTS.disable_suppliersV2, "post");
                if (response.status) {
                    setsupplierSet(prevState => prevState.filter(e => e.id !== currentSupplierInfo.id));
                    closeDelteSupplier();
                }
            } catch (error) {
                message.error(error.message);
            }
        }
    }
    const closeSupplierAddModalAdv = () => {
        clearSupplierFormData();
        set_whatsapp_number_status(deafaultNumberInfo)
        handleAddSupplierClose();
        setCurrentSupplierInfo([]);
        setSupplierAddEditModalTitle(`Add New Supplier`);
    }

    //Edit supplier
    const handleEditSupplier = (record) => {
        setSupplierAddEditModalTitle(`Edit Info of Supplier '${record?.id}. ${record?.name}'`);

        setSupplierName(record?.name)
        setSupplierContactPersonName(record?.contact_person);
        setSupplierAddress(record?.address);
        setSupplierTags(record?.tag);
        setSupplierMob(record?.number);

        handleAddSupplierOpen();
        setSupplierId(record?.id);
    }
    const handleEnableSupplier = (match) => {
        Modal.confirm({
            title: `Enable Supplier?`,
            content: `Re-enable "${match.name || match.number}"? They will become active again.`,
            okText: "Enable",
            okType: "primary",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    const res = await CommonApiCall(
                        { api_key: "uzdpart", id: match.id },
                        API_ENDPOINTS.enable_suppliersV2,
                        "post"
                    );
                    if (res?.status) {
                        message.success("Supplier enabled successfully");
                        clearSupplierFormData();
                        setAddSupplierModal(false);
                        reload_supplier_data();
                    } else {
                        message.error("Failed to enable supplier");
                    }
                } catch {
                    message.error("Error enabling supplier");
                }
            }
        });
    };

    const reload_supplier_data = async () => {
        try {
            setTableLoading(true);
            const response = await CommonApiCall({ api_key: "uzdpart", search: searchTerm, }, API_ENDPOINTS.get_suppliersV2, "post");
            if (response.status) {
                setsupplierSet(response.data);
            }
        } catch (error) {
            message.error(error.message);
        }
        finally {
            setTableLoading(false);
        }
    };
    const reload_supplier_tags = async () => {
        setSupplier_tag_loading(true);
        try {
            var res = await axios.post(API_DOMAIN + "/whatsapp/get_supplier_tags", { api_key: "uzdpart" })
            if (res.data.success) {
                setTableLoading(false);
                setTagSet(res.data.data);
                var tagSetTemp = res.data.data.map((item, index) => ({
                    value: item.id,
                    label: item.name
                }));
                setTagSuggestions(tagSetTemp);
            }

        } catch (error) {
            setTableLoading(false);
            message.error(error.message);
        }
        finally {
            setSupplier_tag_loading(false);
        }
    };
    const loadTags = async () => {
        setTagManagementButtonLoading(true);
        try {
            const response = await CommonApiCall({
                api_key: "uzdpart"
            }, API_ENDPOINTS.get_supplier_tags, "post");
            if (response.status) {
                setTagSet(response.data);
                setFilteredTagsTable(response.data);
            }
        } catch (error) {
            message.error(error.message);
        }
        finally {
            setTagManagementButtonLoading(false);
        }
    };
    const handleTagManagement = async () => {
        await loadTags();
        //open the tag main model if it is not in the add supplier modal
        if (!addSupplierModal)
            handleTagMainModalOpen();
    }
    const supplier_mobile_validity_check = async (number) => {
        try {
            const response = await CommonApiCall({ api_secret: "uzdpart", phone: number }, API_ENDPOINTS.get_wa_status, "post");

            if (response?.status) {
                switch (response?.status) {
                    case 0:
                        break;
                    case 1:
                        if (supplierAddEditModalTitle.includes(`Edit Info`)) {
                            setValidMobileNumber(true)
                            set_whatsapp_number_status((
                                <div>
                                    <div className='mb-2' style={{ color: "green" }}>This Supplier has a valid Whatsapp Number</div> <b>{response?.data?.[0]?.name || <i>Name Not Added</i>}</b>&nbsp;(ID : {response?.data?.[0]?.id})
                                    <div>{response?.data?.[0]?.contact_person || (<i>Contact Person Name Not Added</i>)},</div>
                                    <div>{response?.data?.[0]?.address || (<i>Address Not Added</i>)}</div>
                                </div>))
                        }
                        else {
                            setValidMobileNumber(false)
                            set_whatsapp_number_status((
                                <div>
                                    <div className='mb-2' style={{ color: "#d4bc33" }}>The number Already exists in Database as</div> <b>{response?.data?.[0]?.name || <i>Name Not Added</i>}</b>&nbsp;(ID : {response?.data?.[0]?.id})
                                    <div>{response?.data?.[0]?.contact_person || (<i>Contact Person Name Not Added</i>)},</div>
                                    <div>{response?.data?.[0]?.address || (<i>Address Not Added</i>)}</div>
                                </div>))
                        }
                        break;
                    case 2:
                        if (response?.data?.numberExists) {
                            setValidMobileNumber(true);
                            set_whatsapp_number_status((<div style={{ color: "green" }}>The number is <b>Available</b> on WhatsApp</div>))
                        }
                        else {
                            setValidMobileNumber(false);
                            set_whatsapp_number_status((<div style={{ color: "#ff7c73" }}>The number is <b>Unavailable</b> on WhatsApp</div>))
                        }
                        break;
                    default:
                        break;
                }
            }


            // if (!response.status && response.data.length > 0) {
            //     wa_status = "Supplier Already Exists (" + response.data[0].name + ")";
            //     setformValid(false);
            //     document.getElementById("wa_valid").style = "color:red;";
            // }
            // if (response.status && response.data.status == 200) {
            //     wa_status = "YES";
            //     setformValid(true);
            //     document.getElementById("wa_valid").style = "color:green;text-align:right;padding-right:10px;";
            // }
            // if (response.status && response.data.status == 404) {
            //     wa_status = "NO";
            //     setformValid(false);
            //     document.getElementById("wa_valid").style = "color:red;text-align:right;padding-right:10px;";
            // }
        } catch (error) {
            message.error(error.message);
        }
    };
    const handleSupAdd = async () => {
        try {
            setAddModalButtonLoading(true);
            if (!validMobileNumber) {
                message.warning(`Enter a valid phone number`);
                return;
            }
            else if (!SupplierName) {
                message.warning(`Enter a valid Supplier Name`);
                return;
            }
            else if (SupplierTags?.length == 0) {
                message.warning(`Select correct Tags for the supplier`);
                return;
            }
            else {
                const res = await axios.post(API_DOMAIN + "/whatsapp/add_suppliersV2", {
                    api_key: "uzdpart", name: SupplierName?.trim(), number: SupplierMob, address: SupplierAddress?.trim(), tag: SupplierTags, id: supplierId, contact_person: SupplierContactPersonName?.trim()
                })

                if (res.data.success) {
                    setsupplierSet(res.data.data);
                    message.success(res.data.message);
                    closeSupplierAddModalAdv();
                }
                else {
                    message.error(res.data.message);
                }
            }
        } catch (error) {
            message.error(error.message)
        }
        finally {
            setAddModalButtonLoading(false);
        }
    };

    useEffect(() => {
        reload_supplier_data();
        reload_supplier_tags();
    }, []);

    const displayedSuppliers = supplierSet
        .filter(s => !excludeUzdpart || !s.name?.toLowerCase().includes("uzdpart"))
        .filter(s => !tagFilter.length || s.tag?.some(t => tagFilter.includes(t.value)));

    const supplierTableColumns = [
        {
            title: 'Sl. No.',
            render: (text, record, index) => index + 1,
            width: "5%"
        },
        {
            title: 'Supplier Name',
            render: (record) => (
                <React.Fragment>
                    <div className="flex items-center">
                        {!record?.tag?.length != 0 ? (
                            <Tooltip title="This suppplier doesn't have any tags, it never gets any queries passed.">
                                <div style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "red",
                                    borderRadius: "5px"
                                }} />
                            </Tooltip>
                        ) : null}
                        &nbsp;
                        {record?.name}
                    </div>
                </React.Fragment>
            )
        },
        {
            title: 'Contact Person',
            dataIndex: 'contact_person',
        },
        {
            title: 'Supplier Address',
            dataIndex: 'address',
        },
        {
            title: 'Supplier Number',
            dataIndex: 'number',
        },
        {
            title: 'Tags',
            render: (record) => (
                record?.tag?.length
                    ? <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        {record.tag.map((item, i) => <Tag key={i} color="blue">{item.label}</Tag>)}
                      </div>
                    : <span style={{ fontSize: 12, color: "#aaa" }}><i>No tags</i></span>
            )
        },
        {
            title: 'Actions',
            render: (text, record, index) => (
                <div className='flex justify-between pl-2 pr-2'>
                    <Tooltip placement="left" title="Edit Supplier information.">
                        <EditOutlined onClick={() => handleEditSupplier(record)} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" />
                    </Tooltip>

                    <Tooltip placement="top" title="Delete this Supplier.">
                        <DeleteOutlined style={{ color: "#ff7c73" }} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => handleDeleteSupplier(record)} />
                    </Tooltip>

                </div>
            ),
            width: "6%"
        },
    ]

    const tagsTableColumns = [
        {
            title: 'Sl. No.',
            render: (text, record, index) => index + 1,
            width: "5%"
        },
        {
            title: 'Tag Name',
            render: (text, record, index) => (
                <div className="flex items-center">
                    {!record?.tagged_suppliers?.length != 0 ? (
                        <Tooltip title="This tag doesn't have any Suppliers, it never gets any queries passed.">
                            <div style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: "red",
                                borderRadius: "5px"
                            }} />
                        </Tooltip>
                    ) : null}
                    &nbsp;
                    {record?.name}
                </div>
            )
        },
        {
            title: 'Tagged Suppliers',
            render: (record) => {
                const valid = record?.tagged_suppliers?.filter(Boolean);
                return valid?.length
                    ? <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        {valid.map((name, i) => <Tag key={i}>{name}</Tag>)}
                      </div>
                    : <span style={{ fontSize: 12, color: "#aaa" }}><i>No suppliers tagged</i></span>;
            }
        },
        {
            title: 'Actions',
            render: (text, record, index) => (
                <div className='flex justify-center pl-2 pr-2'>
                    <Tooltip placement="top" title="Delete this Tag.">
                        <DeleteOutlined style={{ color: "#ff7c73" }} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => handleTagDelete(record)} />
                    </Tooltip>

                </div>
            ),
            width: "6%"
        }
    ]

    useEffect(() => {
        clearTimeout(phoneCheckTimerRef.current);
        setDuplicateSupplier(null);

        if (!SupplierMob) {
            set_whatsapp_number_status(deafaultNumberInfo);
            return;
        }

        const number_validity = validatePhoneNumber(SupplierMob);

        // In add mode, search for an existing supplier with this number
        if (!supplierId) {
            phoneCheckTimerRef.current = setTimeout(async () => {
                try {
                    const response = await CommonApiCall(
                        { api_key: "uzdpart", search: SupplierMob },
                        API_ENDPOINTS.get_suppliersV2,
                        "post"
                    );
                    if (response?.status && response.data?.length > 0) {
                        const match = response.data.find(s =>
                            (s.number || "").replace(/\D/g, "").endsWith(SupplierMob.replace(/\D/g, "")) ||
                            SupplierMob.replace(/\D/g, "").endsWith((s.number || "").replace(/\D/g, ""))
                        );
                        if (match) {
                            setDuplicateSupplier(match);
                            setValidMobileNumber(false);
                            const isDisabled = match.status === 0;
                            set_whatsapp_number_status(
                                <div>
                                    <div className='mb-2 font-semibold' style={{ color: "#d4380d" }}>
                                        ⚠️ A supplier with this number already exists:
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                        <b>{match.name || <i>No name</i>}</b>
                                        <span style={{ color: "#8c8c8c", fontSize: 11 }}>(ID: {match.id})</span>
                                        {isDisabled
                                            ? <Tag color="red" style={{ fontSize: 10, margin: 0 }}>Disabled</Tag>
                                            : <Tag color="green" style={{ fontSize: 10, margin: 0 }}>Active</Tag>
                                        }
                                    </div>
                                    {match.supplier_score > 0 && (
                                        <div className='mt-1'>
                                            <Rate disabled value={match.supplier_score} style={{ fontSize: 14 }} />
                                        </div>
                                    )}
                                    {match.contact_person && <div style={{ color: "#595959" }}>{match.contact_person}</div>}
                                    {match.address && <div style={{ color: "#595959", fontSize: 11 }}>{match.address}</div>}
                                    {isDisabled && (
                                        <div className='mt-1' style={{ color: "#8c8c8c", fontSize: 11 }}>
                                            <b>Disabled reason:</b> {match.stop_reason || <i>No reason recorded</i>}
                                        </div>
                                    )}
                                    {match.tag?.length > 0 && (
                                        <div className='mt-1' style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                                            {match.tag.map(t => <Tag key={t.value} color="blue" style={{ fontSize: 10 }}>{t.label || t.value}</Tag>)}
                                        </div>
                                    )}
                                    <div className='mt-2' style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                        <span style={{ color: "#d4380d", fontSize: 11 }}>
                                            Cannot save — {isDisabled ? "re-enable the existing supplier instead." : "edit the existing supplier instead."}
                                        </span>
                                        {isDisabled ? (
                                            <Button
                                                size="small"
                                                type="primary"
                                                onClick={() => handleEnableSupplier(match)}
                                            >Enable Supplier</Button>
                                        ) : (
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    setDuplicateSupplier(null);
                                                    setValidMobileNumber(true);
                                                    set_whatsapp_number_status(
                                                        <div style={{ color: "#1677ff", fontSize: 11, display: "flex", alignItems: "center", gap: 4 }}>
                                                            ✏️ Editing existing supplier: <b>{match.name || match.number}</b> (ID: {match.id})
                                                        </div>
                                                    );
                                                    handleEditSupplier(match);
                                                }}
                                            >Edit</Button>
                                        )}
                                    </div>
                                </div>
                            );
                            return;
                        }
                    }
                    // No duplicate found — proceed with WhatsApp check if number is valid
                    setDuplicateSupplier(null);
                    if (number_validity?.valid) {
                        supplier_mobile_validity_check(SupplierMob);
                    } else {
                        set_whatsapp_number_status(deafaultNumberInfo);
                    }
                } catch {
                    if (number_validity?.valid) supplier_mobile_validity_check(SupplierMob);
                    else set_whatsapp_number_status(deafaultNumberInfo);
                }
            }, 500);
        } else {
            // Edit mode — skip duplicate check, just validate WhatsApp
            if (number_validity?.valid) {
                supplier_mobile_validity_check(SupplierMob);
            } else {
                set_whatsapp_number_status(deafaultNumberInfo);
            }
        }
    }, [SupplierMob]); // eslint-disable-line


    //Tag Management Main Modal
    const [tagMainModalView, setTagMainModalView] = useState(false);
    const handleTagMainModalOpen = () => {
        setTagMainModalView(true);
    }
    const handleTagMainModalClose = () => {
        setTagMainModalView(false);
    }

    const [searchTag, setSearchTag] = useState(null);
    const [filteredTagsTable, setFilteredTagsTable] = useState([]);

    const handleTagSearch = (value) => {
        setSearchTag(value);
        setFilteredTagsTable(value ? tagSet.filter(e => e.name.toLowerCase().includes(value?.toLowerCase())) : tagSet);
    }


    //Add new tag modal and related stuff
    const [tagAddModalView, setTagAddModalView] = useState(false);
    const [newTagValue, setNewTagValue] = useState(null);
    const [addTagSaveButtonLoading, setAddTagSaveButtonLoading] = useState(false);

    const handleTagAddModalOpen = () => {
        setTagAddModalView(true);
    }
    const handleTagAddModalClose = () => {
        setTagAddModalView(false);
    }
    const handleTagAddModalCloseAdv = () => {
        setNewTagValue(null);
        setTagAddModalView(false);
    }

    const handleTagAddAction = async () => {
        try {
            const response = await CommonApiCall({
                api_key: "uzdpart",
                tag: newTagValue?.trim()
            }, API_ENDPOINTS.add_supplier_tags, "post");
            if (response.status) {
                message.success("Added new tag!");
                setNewTagValue(null);
                return 1;
            }
            else {
                message.error(response.message);
            }
        } catch (error) {
            message.error(error.message);
        }
    };

    const handleTagAdd = async () => {
        if (!newTagValue) {
            message.warning(`Please enter a valid Tag name`)
            return;
        }
        setAddTagSaveButtonLoading(true);
        if (addSupplierModal) {
            try {
                const response = await handleTagAddAction();
                if (response) {
                    handleTagAddModalCloseAdv();
                    await reload_supplier_tags();
                }
            } catch (error) {
                message.error(error.message);
            }
            finally {
                setAddTagSaveButtonLoading(false);
            }
        } else {
            try {
                const response = await handleTagAddAction();
                if (response) {
                    handleTagAddModalCloseAdv();
                    setTableLoading(true);
                    await handleTagManagement();
                    setTableLoading(false);
                }
            } catch (error) {
                message.error(error.message);
            }
            finally {
                setAddTagSaveButtonLoading(false);
                setSearchTag(null);
            }
        }
    }

    const handleTagDelete = async (tag) => {
        if (!tag)
            message.error(`Not a valid tag`)
        else {
            try {
                setTableLoading(true);
                const res = await handleTagDeleteAction(tag);
                if (res) {
                    handleTagAddModalClose();
                    await handleTagManagement();
                }

            } catch (error) {
                message.error(error.message);
            }
            finally {
                setTableLoading(false);
                setSearchTag(null);
            }
        }
    }

    const handleTagDeleteAction = (tag) => new Promise((resolve) => {
        Modal.confirm({
            title: "Delete Tag",
            content: `${tag?.tagged_supplier_count} supplier${tag?.tagged_supplier_count !== 1 ? "s are" : " is"} tagged with "${tag.name}". Are you sure you want to delete it?`,
            okText: "Delete",
            okButtonProps: { danger: true },
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    await deleteTag(tag.id);
                    message.success("Tag deleted successfully");
                    resolve(true);
                } catch (error) {
                    message.error(error.message);
                    resolve(false);
                }
            },
            onCancel: () => resolve(false),
        });
    });
    const deleteTag = async (id) => {
        try {
            const response = await CommonApiCall({
                api_key: "uzdpart",
                id: id
            }, API_ENDPOINTS.delete_supplier_tags, "post");

            if (response.status) {
                return response.data;
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            throw new Error(error.message);
        }
    };
    return (
        <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: 12, padding: "10px 14px", background: "#fff", border: "1px solid #e8e8e8", borderRadius: 8, marginBottom: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", position: "sticky", top: 70, zIndex: 1000 }}>
                <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", gap: 8, minWidth: 0 }}>
                    <Input
                        style={{ width: 220, flexShrink: 0 }}
                        allowClear
                        prefix={<SearchOutlined style={{ color: "#bbb" }} />}
                        placeholder="Search name, number or tag…"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") reload_supplier_data(); if (e.key === "Escape") setSearchTerm(""); }}
                    />
                    <Button type="primary" style={{ flexShrink: 0 }} onClick={() => reload_supplier_data()}>Search</Button>
                    <Checkbox style={{ flexShrink: 0, whiteSpace: "nowrap" }} checked={excludeUzdpart} onChange={e => setExcludeUzdpart(e.target.checked)}>Exclude Uzdpart</Checkbox>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Filter by tag…"
                        options={tagSuggestions}
                        value={tagFilter}
                        onChange={setTagFilter}
                        optionFilterProp="label"
                        maxTagCount="responsive"
                        style={{ minWidth: 160, flex: 1 }}
                    />
                    <span style={{ fontSize: 12, color: "#888", whiteSpace: "nowrap", flexShrink: 0 }}>
                        {displayedSuppliers.length !== supplierSet.length
                            ? `${displayedSuppliers.length} of ${supplierSet.length} suppliers`
                            : `${supplierSet.length} supplier${supplierSet.length !== 1 ? "s" : ""}`}
                    </span>
                </div>
                <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                    <Tooltip title="Add new supplier">
                        <Button type="primary" icon={<PlusSquareOutlined />} onClick={handleAddSupplierOpen}>Add Supplier</Button>
                    </Tooltip>
                    <Tooltip title="Manage tags">
                        <Button loading={tagManagementButtonLoading} icon={<ClusterOutlined />} onClick={handleTagManagement}>Tags</Button>
                    </Tooltip>
                </div>
            </div>

            <div>
                <Table
                    rowKey={(record) => record.id}
                    dataSource={displayedSuppliers}
                    className="drop-shadow border rounded"
                    style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important" }}
                    columns={supplierTableColumns}
                    loading={tableLoading}
                    bordered={true}
                    pagination={{
                        position: ["topRight", "bottomRight"],
                    }}
                />
            </div>

            {/* Add Supplier Modal */}
            <Modal
                title={supplierAddEditModalTitle}
                open={addSupplierModal}
                onCancel={closeSupplierAddModalAdv}
                centered
                width={840}
                maskClosable={false}
                footer={< div className="flex justify-end" >
                    <div>
                        <Button
                            variant="contained"
                            loading={addModalButtonLoading}
                            disabled={!!duplicateSupplier}
                            style={{ backgroundColor: duplicateSupplier ? undefined : "green", color: "white" }}
                            onClick={handleSupAdd}
                        ><SaveOutlined />Save
                        </Button>
                    </div>
                </div >}>
                <div className="flex border rounded drop-shadow p-2" style={{ backgroundColor: "#f7f7f7" }}>
                    <div className="gap-2 grid p-2" style={{ maxWidth: "50%" }}>
                        <div >
                            <Input
                                placeholder="Whatsapp Number"
                                allowClear
                                required
                                focus={true}
                                value={currentSupplierInfo?.number || SupplierMob}
                                onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/\D/g, "");
                                    setSupplierMob(onlyNumbers);
                                }}
                            />
                            <div style={{ color: "gray", fontSize: "12px" }}>
                                <i>Please add country code to the number and avoid adding the + sign</i>
                            </div>
                            <div className='border rounded p-2 mt-2 drop-shadow'>
                                <div className='flex justify-center'>
                                    IS THIS NUMBER AVAILABLE ON WHATSAPP ?
                                </div>
                                <div className='mt-3'>
                                    <div className='border rounded p-2' style={{ backgroundColor: "#fbfbfb", height: "150px", overflowY: "auto" }}>
                                        {whatsapp_number_status}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Divider style={{ height: "auto" }} type="vertical" />

                    <div style={{ width: "50%" }} className='p-2'>
                        <Input
                            placeholder="Name of the Supplier"
                            allowClear
                            required
                            value={SupplierName}
                            onChange={(e) => {
                                setSupplierName(e.target.value);
                            }}
                        />
                        <Input
                            placeholder="Name of Contact Person"
                            className='mt-2'
                            allowClear
                            required
                            value={SupplierContactPersonName}
                            onChange={(e) => {
                                setSupplierContactPersonName(e.target.value);
                            }}
                        />
                        <TextArea
                            className='mt-2'
                            placeholder="Address of the Supplier"
                            allowClear
                            required
                            value={SupplierAddress}
                            onChange={(e) => {
                                setSupplierAddress(e.target.value);
                            }}
                            autoSize={{
                                minRows: 3,
                                maxRows: 5,
                            }}
                        />
                        <div>

                            <div className='flex justify-between mt-2 mb-2 align-middle mr-1 ml-1' style={{ color: "gray", fontSize: "10px" }}>
                                <i>Total Tags Selected :&nbsp;<b>{SupplierTags?.length || 0}</b></i>
                                <Tooltip title="Select All Tags at once" placement="right">
                                    <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                                    </Checkbox>
                                </Tooltip>
                            </div>
                            <div className='flex justify-between supplier-add-modal-tags' style={{ width: "100%" }}>
                                <Space>
                                    <Space.Compact>
                                        <Select
                                            className='supplier-add-tag'
                                            mode="multiple"
                                            allowClear
                                            style={{ overflowY: "auto" }}
                                            optionFilterProp="label"
                                            placeholder="Select Supplier Tags"
                                            value={SupplierTags}
                                            onChange={(e) => handleSupplierTagChange(e)}
                                            options={tagSuggestions}
                                            loading={supplier_tag_loading}
                                        />
                                        <Tooltip title="Add a new Tag" placement="left">
                                            <Button onClick={handleTagAddModalOpen}>+</Button>
                                        </Tooltip>
                                    </Space.Compact>
                                </Space>


                            </div>
                        </div>
                    </div>


                </div>
            </Modal >

            {/* Delete Supplier Modal */}
            <Modal
                title={`Delete Supplier`}
                open={deleteFinalSupplierModal}
                onCancel={handledeleteFinalSupplierModalClose}
                centered
                width={700}
                maskClosable={false}
                footer={< div className="flex justify-end" >
                    <div>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: "#ff7c73", color: "white" }}
                            onClick={handleSupplierDelete}
                        ><DeleteOutlined />Delete
                        </Button>
                    </div>
                </div >}>

                <div className='border flex justify-between rounded p-2' style={{ backgroundColor: "#f7f7f7" }}>
                    <div className='border rounded m-2 p-2' style={{ width: "500px" }}>
                        <div className='flex justify-center' style={{ fontSize: "16px" }}><u>SUPPLIER INFORMATION</u></div>

                        <div className='mt-2 ml-2' style={{ fontSize: "10px", color: "gray" }}><i>ID :&nbsp;<b>{currentSupplierInfo?.id}</b></i></div>
                        <div className='border rounded p-2' style={{ backgroundColor: "#fbfbfb" }}>
                            <div className='mt-2'><WhatsAppOutlined className='mr-2' />&nbsp;<b>{currentSupplierInfo?.number}</b></div>
                            <div className='mt-2'><ShopOutlined className='mr-2' />&nbsp;<b>{currentSupplierInfo?.name}</b></div>
                            <div className='mt-2'><UserOutlined className='mr-2' />&nbsp;{currentSupplierInfo?.contact_person || (<i style={{ color: "gray" }}>Contact person name not added</i>)}</div>
                            <div className='mt-2'><EnvironmentOutlined className='mr-2' />&nbsp;{currentSupplierInfo?.address || (<i style={{ color: "gray" }}>Address not added</i>)}</div>
                        </div>


                        <div className='border rounded mt-2 p-2' style={{ width: "274px", height: "80px", overflowY: "auto", backgroundColor: "#fbfbfb" }}>
                            {currentSupplierInfo?.tag?.length > 0 ? currentSupplierInfo?.tag?.map((tag, index) => (<div>{index + 1}.&nbsp;{tag?.label}</div>)) : (<i style={{ color: "gray" }}>No tags were added</i>)}
                        </div>
                        <div className='flex justify-end pr-2' style={{ fontSize: "10px", color: "gray" }}>Total tags :&nbsp;{currentSupplierInfo?.tag?.length || 0}</div>
                    </div>
                    <div className='border rounded m-2 p-2'>
                        <div className='mt-2 ml-1'>Reason for disabling the Supplier </div>
                        <TextArea
                            className='mb-2'
                            placeholder={null}
                            allowClear
                            required
                            autoFocus={true}
                            value={supplierDisableReason}
                            onChange={(e) => {
                                setSupplierDisableReason(e.target.value);
                            }}
                            autoSize={{
                                minRows: 8,
                                maxRows: 10,
                            }}
                        />
                        <div className='p-2'><InfoCircleOutlined />&nbsp;This Supplier will be <b style={{ color: "red" }}>Disabled</b> and future Queries <b style={{ color: "red" }}>will not be shared</b> to them.</div>
                    </div>
                </div>

            </Modal >

            {/* Tag Management Main Modal */}
            <Modal
                title={`Manage Tags`}
                open={tagMainModalView}
                onCancel={handleTagMainModalClose}
                centered
                width={700}
                maskClosable={false}
                footer={< div className="flex justify-center" >
                    Total Number of Tags in Database :&nbsp;<b>{tagSet?.length || 0}</b>
                </div >}>
                <div className='border rounded m-2 p-3' style={{ backgroundColor: "#f7f7f7" }}>
                    <div className='flex justify-between'>
                        <Input
                            style={{ width: "85%" }}
                            allowClear
                            className='mb-2'
                            placeholder="Search Tag"
                            value={searchTag}
                            onChange={(e) => handleTagSearch(e.target.value)}
                            onKeyDown={(event) => { if (event.key === 'Enter') { reload_supplier_data(event.target.value); } else if (event.key === 'Escape') { setSearchTerm(null) } }}
                        />
                        <Tooltip title="Add new Tag">
                            <Button style={{ width: "10%" }} type="primary" onClick={handleTagAddModalOpen}>
                                <PlusOutlined />
                            </Button>
                        </Tooltip>
                    </div>
                    <Table
                        rowKey={(record) => record.id}
                        dataSource={filteredTagsTable}
                        className="drop-shadow border rounded"
                        style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important", height: "60vh" }}
                        columns={tagsTableColumns}
                        bordered={true}
                        pagination={false}
                        loading={tableLoading}
                    />
                </div>

            </Modal >

            {/* Tag Add Modal */}
            <Modal
                title={`Add new Tag`}
                open={tagAddModalView}
                onCancel={handleTagAddModalCloseAdv}
                centered
                width={500}
                maskClosable={false}
                footer={
                    < div className="flex justify-end" >
                        <Button
                            variant="contained"
                            loading={addTagSaveButtonLoading}
                            style={{ backgroundColor: "green", color: "white" }}
                            onClick={handleTagAdd}
                        ><SaveOutlined />Save
                        </Button>
                    </div >
                }>
                <div className='border rounded p-3' style={{ backgroundColor: "#f7f7f7" }}>
                    <Input
                        allowClear
                        placeholder="Enter Tag Name"
                        value={newTagValue}
                        onChange={(e) => setNewTagValue(e.target.value)}
                    />
                </div>
            </Modal >

        </ >

    );

}

export default Supplier
